import { useState, useEffect, useCallback } from 'react';
import * as rolesApi from '../api/roles';
export { usePermissionsContext as useCanI } from '../contexts/PermissionsContext';

export function useRoles() {
  const [roles, setRoles]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await rolesApi.getRoles();
      setRoles(data.roles || []);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al cargar roles');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { roles, loading, error, reload: load };
}

export function usePermissions() {
  const [permissions, setPermissions] = useState([]);
  const [byModule, setByModule]       = useState({});
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);

  useEffect(() => {
    rolesApi.getAllPermissions()
      .then(data => {
        setPermissions(data.permissions || []);
        setByModule(data.byModule || {});
      })
      .catch(e => setError(e.response?.data?.error || 'Error al cargar permisos'))
      .finally(() => setLoading(false));
  }, []);

  return { permissions, byModule, loading, error };
}
